import type { AirportBusProviderConfig } from "../config/types";

/**
 * Vienna Airport Bus (VALN) provider config.
 * Passenger types: Distribusion VALN — Adult (PNOS) 15–99, Child (PCIL) 6–14.
 * Branding (title/logo/description) comes from the provider info API at runtime.
 */
export const viennaAirportBusConfig: AirportBusProviderConfig = {
  slug: "vienna-airport-bus",
  fallbackDisplayName: "Vienna Airport Bus",
  passengerTypes: [
    {
      code: "PNOS",
      labelKey: "transport.viennaAirportBusPassengerTypeAdult"
    },
    {
      code: "PCIL",
      labelKey: "transport.viennaAirportBusPassengerTypeChild"
    }
  ],
  defaultPassengerTypeCode: "PNOS",
  estimationTimeStrategy: "current-local-time",
  i18n: {
    validity: "transport.viennaAirportBusValidity",
    nonRefundable: "transport.viennaAirportBusNonRefundable"
  }
};
